import Fancybox from '@fancyapps/fancybox'
import '../plugins/project-gallery'

export default {
  init() {
    $('.card-attachment:not(.--cta)').fancybox({
      baseClass : 'fancybox-project-content',
      afterShow: function( instance, current ) {
        $('.fancybox-content .js-project-gallery-wrapper').each(function() {
          $(this).projectGallery();
        })
        $('.fancybox-content img').css('opacity', 1);
      }
    })
  },
}
